// extracted by mini-css-extract-plugin
var _1 = "MyAccountNav_active__U5uSz";
var _2 = "MyAccountNav_nav__qCbsl";
var _3 = "MyAccountNav_navContainer__zuzAE";
var _4 = "MyAccountNav_tab__669bo";
export { _1 as "active", _2 as "nav", _3 as "navContainer", _4 as "tab" }
